<template>
  <div>
    <v-layout
      row
      wrap
    >
      <v-flex
        xs3
        style="text-align:center;margin-top:25px;"
      >
        <v-icon
          size="155"
          style="color: #FDD835 !important; -webkit-text-stroke: 4px black;"
        >
          notifications
        </v-icon>
        <h2 style="font-weight:300">Your Notifications</h2>
      </v-flex>
      <v-flex
        xs9
      >
        <v-card>
          <v-card-text>
            <v-data-table
              :items="notifications"
              :headers="headers"
              :pagination.sync="pagination"
              :total-items="totalNotifications"
              :rows-per-page-items="paginationStrings"
              :loading="loading"
              disable-initial-sort
            >
              <template slot="no-data">
                <tr>
                  <td colspan="5">
                    <div style="text-align:center;padding:25px;">
                      <v-icon size="125px">notifications_none</v-icon>
                      <h3>No Notifications</h3>
                    </div>
                  </td>
                </tr>
              </template>
              <template
                slot="items"
                slot-scope="props"
              >
                <tr :class="{ unread: !props.item.read_at }">
                  <td>
                    <div
                      style="position:relative;width:100%;padding:15px;"
                    >
                      <div
                        @click="readAndGo(props.item)"
                        style="width:100%;height:100%;"
                      >
                        <v-icon
                          v-if="props.item.type == 'File Upload Notification'"
                          left
                          style="float:left;"
                        >
                          inbox
                        </v-icon>
                        <v-icon
                          v-else-if="props.item.type == 'Form Notification' || props.item.type == 'Form Signature Notification'"
                          left
                          style="float:left;"
                        >
                          assignment
                        </v-icon>
                        <v-icon
                          v-else-if="props.item.type == 'Message from Client'"
                          left
                          style="float:left;"
                        >
                          forum
                        </v-icon>
                        <v-icon
                          v-else
                          left
                          style="float:left;"
                        >
                          build
                        </v-icon>
                        <span style="display:block;font-weight:600;">{{ props.item.message }}</span>
                        <span style="display:block;font-size:12px;">{{ convertToLocal(props.item.sent_at) }}</span>
                      </div>
                      <div
                        v-if="!props.item.read_at"
                        class="readOnly"
                        @click="read(props.item)"
                      >
                        <v-icon
                          color="grey"
                          style="vertical-align:middle;"
                        >
                          archive
                        </v-icon>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import pagination from '@/components/global/pagination'

export default {
  name: 'UserCurrentNotifications',
  mixins: [
    pagination
  ],
  data () {
    return {
      loading: false,
      notifications: [],
      pagination: {},
      paginationStrings: [
        10
      ],
      headers: [
        { text: 'Your Notifications', align: 'center', sortable: false }
      ],
    }
  },
  computed: {
    ...mapGetters('notifications', [
      'unreadNotifications',
    ]),
    totalNotifications () {
      return this.pagination.totalItems
    }
  },
  created () {
    this.documentTitle('My Notifications')
  },
  methods: {
    ...mapMutations('notifications', [
      'setUnreadCount',
    ]),
    fetch () {
      this.loading = true
      api.users.notifications.get({count: this.pagination.rowsPerPage || 10, pageNum: this.pagination.page})
        .then(notifications => {
          this.pagination.page = notifications.page_number
          this.pagination.totalItems = notifications.count
          this.notifications = notifications.results
          this.setUnreadCount(notifications.unread)
          this.componentCreated = true
          this.loading = false
        })
    },
    readAndGo (notification) {
      this.loading = true
      api.users.notifications.read(notification.id)
        .then(() => {
          if (notification.read_at === null) {
            this.setUnreadCount(this.unreadNotifications - 1)
          }
          notification.read_at = 'now'
          if (notification.userforms.length > 0) {
            this.$router.push({ name: 'UserForm', params: { id: notification.userforms[0] } })
          } else if (notification.contactfiles.length > 0) {
            this.$router.push({ name: 'Contact', params: { id: notification.contact } })
          } else if (notification.contact !== null) {
            this.$router.push({ name: 'Contact', params: { id: notification.contact } })
          } else {
            this.$router.push({ name: 'ReportList' })
          }
          this.loading = false
        })
    },
    read (notification) {
      this.loading = true
      api.users.notifications.read(notification.id)
        .then(() => {
          if (notification.read_at === null) {
            this.setUnreadCount(this.unreadNotifications - 1)
          }
          notification.read_at = 'now'
          this.loading = false
        })
    }
  }
}
</script>

<style>
.unread {
  background-color: #FFF176;
}
</style>
